export const layoutClassNames = Object.freeze({
  pageContainer: 'riven_auth_page-container',
  mainContent: 'riven_auth_main-content',
  customContent: 'riven_auth_custom-content',
  signature: 'riven_auth_signature',
  brandingHeader: 'riven_auth_branding-header',
});
